if (!customElements.get('faq-component')) {
    customElements.define(
      'faq-component',
      class FaqComponent extends HTMLElement {
        constructor() {
            super();
            this.questions = this.querySelectorAll('.faq-list__item')
            this.bindEvents();
        }
  
        bindEvents() {
            this.questions.forEach((question) =>
                question.addEventListener('click', this.onFaqClick.bind(this))
            );
        }
  
        onFaqClick(event) {
            event.preventDefault();
            this.questions.forEach((el) => {
              if (el == event.currentTarget) {
                if (el.classList.contains('active')) {
                  el.classList.remove('active')
                } else {
                  el.classList.add('active')
                }
              } else {
                el.classList.remove('active')
              }
            })
        }


      }
    );
  }